import { render, staticRenderFns } from "./Partida.vue?vue&type=template&id=be26c226&scoped=true"
import script from "./Partida.vue?vue&type=script&lang=js"
export * from "./Partida.vue?vue&type=script&lang=js"
import style0 from "./Partida.vue?vue&type=style&index=0&id=be26c226&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be26c226",
  null
  
)

export default component.exports